export abstract class UpdateSubsidyJuridicalModel {

    protected constructor(
        public readonly id:number
    ) {
    }
}